import './mocks.css';

const R = 42;
const C = 2 * Math.PI * R;

/*
 * A circular score gauge, e.g. <ScoreRing value={92} label="Optimal" />.
 * The ring is drawn in `color`; the label text is always shown with it.
 */
export default function ScoreRing({
  value,
  max = 100,
  label,
  color = 'var(--color-blue)',
  size = 120,
  showMax = true,
  className,
}) {
  const clamped = Math.max(0, Math.min(value, max));
  const arc = (clamped / max) * C;
  const name = label ? `${label}: ${value} out of ${max}` : `${value} out of ${max}`;

  return (
    <figure
      className={className ? `score-ring ${className}` : 'score-ring'}
      style={{ '--ring-size': `${size}px`, '--ring-color': color }}
      role="img"
      aria-label={name}
    >
      <span className="score-ring__dial">
        <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
          <circle className="score-ring__track" cx="50" cy="50" r={R} />
          <circle
            className="score-ring__arc"
            cx="50"
            cy="50"
            r={R}
            strokeDasharray={`${arc} ${C}`}
            transform="rotate(-90 50 50)"
          />
        </svg>
        <span className="score-ring__value" aria-hidden="true">
          {value}
          {showMax && <small>/{max}</small>}
        </span>
      </span>
      {label && (
        <figcaption className="score-ring__label" aria-hidden="true">
          {label}
        </figcaption>
      )}
    </figure>
  );
}
